import React, { useEffect, useState, useMemo, useRef } from 'react';
import API from './../../../api';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import AdminCustomerModal from './../../customers/admin/AdminCustomerModal';
import { formatDate, formatPrice, download, debug, swalAlert } from '../../../utils';
import { CiViewList } from "react-icons/ci";
import { FiEdit, FiSend, FiCheck } from "react-icons/fi";
import './admin-orders-list.css';
function AdminOrdersList({
  year_default = '',
  limit = false,
  title = true,
  selector = true,
  thead = true,
  columns = false,
  query = {}
}) {
  const user = useSelector((state) => state.user);
  const config = useSelector((state) => state.config);
  const { t } = useTranslation();
  const [year, setYear] = useState(year_default !== '' ? year_default : new Date().getFullYear());
  const [yearOrders, setYearOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [transferring, setTransferring] = useState(null);
  const [filters, setFilters] = useState({
    orderRef: '',
    client: '',
    prodRef: '',
    delivery: ''
  });
  const [tenantRefModal, setTenantRefModal] = useState(null);
  const [tenantRefValue, setTenantRefValue] = useState('');
  const currentYear = new Date().getFullYear();
  const years = Array.from(new Array(currentYear - 2016 + 1), (val, index) => 2016 + index).reverse();
  // Pagination progressive
  const [batchSize] = useState(5000); // Nombre de lignes à afficher à chaque fois
  const [visibleRows, setVisibleRows] = useState([]);
  const tableBodyRef = useRef(null);
  useEffect(() => {
    setLoading(true);
    getOrders();
  }, [year]);
  useEffect(() => {
    //     setLoading(true);
    //     getOrders();
  }, [yearOrders]);
  const getOrders = async () => {
    const $query = { ...query }
    if (query['year:eq'] == undefined && selector === true) {
      $query['year:eq'] = year;
    }
    /*
    if (Object.keys[$query].length === 0) {
      $query['year:eq'] = year;
    }
      */
    try {
      let url = '/admin/orders?query=' + JSON.stringify($query) + (limit ? '&limit=' + limit.toString() : '');
      // console.log(url); return;
      const response = await API.get(url);
      setYearOrders(response.data);
      setVisibleRows(response.data.slice(0, batchSize)); // Commencer avec un premier batch
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  // Gestion du scroll pour afficher plus de lignes au fur et à mesure
  const handleScroll = () => {
    if (tableBodyRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = tableBodyRef.current;
      console.log(scrollTop, scrollHeight, clientHeight)
      if (scrollTop + clientHeight >= scrollHeight) {
        setVisibleRows(prevRows => {
          const nextBatch = yearOrders.slice(prevRows.length, prevRows.length + batchSize);
          // console.log("Loading batch:", nextBatch.length, "new rows");
          return [...prevRows, ...nextBatch];
        });
      }
    }
  };
  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters(prevFilters => ({ ...prevFilters, [name]: value }));
  };
  const filteredOrders = useMemo(() => {
    return visibleRows.filter(order => {
      if (order.items) {
        const preComputedClient = `${order.customer.userCompName} ${order.customer.userName}`.toLowerCase();
        const preComputedDelivery = order.delivery ? `${order.delivery.daCompName} ${order.delivery.daCity}`.toLowerCase() : '';
        const numberMatches = order.orderRef.startsWith(filters.orderRef.toLowerCase()) || order.orderInternalRef.toLowerCase().startsWith(filters.orderRef.toLowerCase());
        const clientMatches = preComputedClient.includes(filters.client.toLowerCase());
        const prodRefMatches = order.items?.some(item => item.itProdRef.includes(filters.prodRef));
        const deliveryMatches = preComputedDelivery.includes(filters.delivery.toLowerCase());
        return numberMatches && clientMatches && prodRefMatches && deliveryMatches;
      } else {
        console.log('Order without item ', order)
        return false;
      }
    });
  }, [visibleRows, filters]);
  /* CUSTOMER MODAL */
  const [customerModalContent, setCustomerModalContent] = useState('');
  const [editedCustomer, setEditedCustomer] = useState(null);
  const handleCustomerModalHide = () => {
    setEditedCustomer(null);
  }
  const handleCustomerCreated = () => { }
  const handleCustomerUpdated = (customer) => {
    const updatedOrders = yearOrders.map(order => {
      if (order.orderUserId === customer.userId) {
        return {
          ...order,
          customer: {
            ...order.customer,
            userCompName: customer.userCompName,
            userName: customer.userName,
            userFirstname: customer.userFirstname
          }
        };
      }
      return order;
    });
    setYearOrders(updatedOrders);
    setEditedCustomer(null);
    setVisibleRows(updatedOrders.slice(0, visibleRows.length)); // pour rafraichier l'affichage
  };
  const handleEditCustomer = async (custId) => {
    const response = await API.get(`/admin/customer/${custId}`);
    setEditedCustomer(response.data);
    return;
  };
  const handleSaveTenantRef = async () => {
    try {
      await API.put(`/admin/order/${tenantRefModal.orderId}`, {
        orderTenantRef: tenantRefValue
      });
      // update local state
      const updated = yearOrders.map(o =>
        o.orderId === tenantRefModal.orderId
          ? { ...o, orderTenantRef: tenantRefValue }
          : o
      );
      setYearOrders(updated);
      setVisibleRows(updated.slice(0, visibleRows.length));
      setTenantRefModal(null);
    } catch (e) {
      console.error(e);
      swalAlert(e.response?.data?.message || "La demande a échoué.")
    }
  };
  useEffect(() => {
    if (editedCustomer !== null) {
      setCustomerModalContent('customer');
    } else {
      setCustomerModalContent('');
    }
  }, [editedCustomer])
  const handleEditTenantRef = (order) => {
    setTenantRefModal(order);
    setTenantRefValue(order.orderTenantRef || '');
  };




  const handleTransferOrder = async (orderId) => {
    try {
      setTransferring(orderId);

      const response = await API.post(`/admin/order/${orderId}/transfer`);

      const updatedOrder = response.data;

      // update state
      const updatedOrders = yearOrders.map(o =>
        o.orderId === orderId ? updatedOrder : o
      );

      setYearOrders(updatedOrders);

      // sync visibleRows
      setVisibleRows(prev =>
        prev.map(o =>
          o.orderId === orderId ? updatedOrder : o
        )
      );
      swalAlert('Commande transférée');

    } catch (e) {
      console.error(e);
      swalAlert(e.response?.data?.message || "Le transfert a échoué.")
    } finally {
      setTransferring(null);
    }
  };
  const getTransferTitle = (date) => {
    if (!date) return 'Transférer la commande';
    return `Transférée le ${formatDate(date, 'd/m/Y H:i')}`;
  };
  return (
    <div id="AdminOrdersList">
      <div className="container">
        {title === true &&
          <div className="page-title">
            <div className="col-12 col-md-3"></div>
            <div className="col-12 col-md-6">
              <h1 className="page-title">  {t('Orders list')}</h1>
            </div>
            <div className="col-12 col-md-3 text-end fw-bold">
              {!loading && <span className="ms-2 pt-2">{formatPrice(yearOrders.length, 0)} Cdes</span>}
            </div>
          </div>
        }
        {loading ? (
          <div className="loading-indicator text-center my-3">
            <div className="spinner-border" role="status">
              <span className="sr-only"></span>
            </div>
            <p>{t('Chargement en cours...')}</p>
          </div>
        ) : (
          <>
            {selector && (
              <div className="row">
                <div className="col-md-3">
                  <div className="input-group mb-3">
                    <div className="input-group-prepend">
                      <label className="input-group-text" htmlFor="yearSelect" style={{ borderRadius: "0.375rem", background: "var(--brand-primary)", color: "#fff" }}>
                        {t('Année')}
                      </label>
                    </div>
                    <select
                      id="yearSelect"
                      className="form-control"
                      value={year}
                      onChange={(e) => setYear(e.target.value)}
                    >
                      {years.map((yearOption) => (
                        <option key={yearOption} value={yearOption}>
                          {yearOption}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            )}
            <div className="table-container" onScroll={handleScroll} ref={tableBodyRef} >
              <table className="table table-sm table-striped">
                {thead && (
                  <thead>
                    <tr>
                      {(columns === false || columns.includes('orderDate')) &&
                        <th>{t('Date')}</th>
                      }
                      {(columns === false || columns.includes('orderRef')) &&
                        <th>
                          <input
                            type="text"
                            className="form-control form-control-sm text-center"
                            placeholder={t('orderRef')}
                            name="orderRef"
                            value={filters.orderRef}
                            onChange={handleFilterChange}
                          />
                        </th>
                      }
                      {(columns === false || columns.includes('customer')) &&
                        <th>
                          <input
                            type="text"
                            className="form-control form-control-sm text-center"
                            placeholder={t('Customer')}
                            name="client"
                            value={filters.client}
                            onChange={handleFilterChange}
                          />
                        </th>
                      }
                      {(columns === false || columns.includes('articles')) &&
                        <th>
                          <input
                            type="text"
                            className="form-control form-control-sm text-center"
                            placeholder={t('prodRefs')}
                            name="prodRef"
                            value={filters.prodRef}
                            onChange={handleFilterChange}
                          />
                        </th>}
                      {(columns === false || columns.includes('delivery')) &&
                        <th>
                          <input
                            type="text"
                            className="form-control form-control-sm text-center"
                            placeholder={t('Delivery')}
                            name="delivery"
                            value={filters.delivery}
                            onChange={handleFilterChange}
                          />
                        </th>
                      }
                      {(columns === false || columns.includes('orderTotalPriceIT')) &&
                        <th>{t('orderTotalPriceIT')}</th>
                      }
                      {(columns == false || columns.includes('download')) &&
                        <th style={{ width: '80px' }}></th>
                      }
                      {config?.tenant?.orders?.transfertEnabled &&
                        <th >
                        </th>
                      }
                    </tr>
                  </thead>
                )}
                <tbody>
                  {filteredOrders.map((order, index) => (
                    <tr key={order.orderId}>
                      {(columns === false || columns.includes('orderDate')) &&
                        <td className='text-center'>{formatDate(order.orderDate)}</td>
                      }
                      {(columns === false || columns.includes('orderRef')) &&
                        <td className='text-center'>
                          <div className='d-flex gap-2'>
                            <div className='flex-grow-1 d-flex flex-column'>
                              <span className='text-success'>
                                W{(order.orderRef ?? '').toString().padStart(6, '0')}
                              </span>
                              <span>{order.orderInternalRef}</span>
                              <span className='text-brand-primary'>{order.orderTenantRef}</span>
                            </div>
                            {config?.tenant?.orders?.tenantRefEnabled &&
                              <FiEdit
                                className="pointer text-brand-primary"
                                onClick={() => handleEditTenantRef(order)}
                              />}
                          </div>
                        </td>
                      }
                      {(columns === false || columns.includes('customer')) &&
                        <td className='text-center'>
                          <span onClick={e => handleEditCustomer(order.orderUserId)} className="text-brand-primary text-decoration-underline pointer">
                            {order.customer.userCompName != '' ? order.customer.userCompName : <>{order.customer.userName} {order.customer.userFirstname}</>}
                          </span>
                        </td>
                      }
                      {(columns === false || columns.includes('articles')) &&
                        <td className="text-center">{order.items.map((item, key) => (
                          <span key={key} onClick={e => download(`/admin/order/item/${item.itId}/datasheet`)} className="pointer text-decoration-underline text-brand-primary">
                            {item.itProdRef} X {item.itQuantity}<br />
                          </span>))}
                        </td>
                      }
                      {(columns === false || columns.includes('delivery')) &&
                        <td className="text-center">
                          {order.delivery && <span >
                            {order.delivery.daCompName !== '' ?
                              <>{order.delivery.daCompName}</>
                              :
                              <>{order.delivery.daName}  {order.delivery.daFirstname}</>
                            }
                          </span>
                          }
                        </td>
                      }
                      {(columns === false || columns.includes('orderTotalPriceIT')) &&
                        <td className="text-center">{formatPrice(order.orderTotalPriceIT)}</td>
                      }
                      {(columns == false || columns.includes('download')) &&
                        <td className="text-center">
                          <a onClick={e => download(`/admin/order/pdf/${order.orderId}`, t)}>
                            <CiViewList size="24" className="text-brand-primary" />
                          </a>
                        </td>
                      }
                      {config?.tenant?.orders?.transfertEnabled &&
                        <td className="text-center">
                          <div className='position-relative pb-2 px-2'
                            title={getTransferTitle(order.orderTransferedAt)}
                          >
                            <FiSend
                              size={20}
                              className={`pointer text-brand-primary ${transferring === order.orderId ? 'opacity-50' : ''}`}
                              onClick={() => handleTransferOrder(order.orderId)}
                            />
                            <div className='position-absolute bottom-0 right-0'>
                              {order.orderTransferedAt && (
                                <FiCheck
                                  size={14}
                                  className="text-success fw-bold"
                                />
                              )}
                            </div>
                          </div>
                        </td>
                      }
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
      {
        (customerModalContent !== '' && editedCustomer) && (
          <AdminCustomerModal
            onHide={handleCustomerModalHide}
            modalContent={customerModalContent}
            editedCustomer={editedCustomer}
            handleCustomerCreated={handleCustomerCreated}
            handleCustomerUpdated={handleCustomerUpdated}
          />
        )
      }
      {
        tenantRefModal && (
          <div className="modal show d-block" tabIndex="-1">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Référence client</h5>
                  <button className="btn-close" onClick={() => setTenantRefModal(null)} />
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Ref AMD</label>
                    <input
                      className="form-control"
                      value={tenantRefModal.orderRef}
                      disabled
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Ref client</label>
                    <input
                      className="form-control"
                      value={tenantRefModal.orderInternalRef}
                      disabled
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Ref {config?.tenant?.name}</label>
                    <input
                      className="form-control"
                      value={tenantRefValue}
                      onChange={(e) => setTenantRefValue(e.target.value)}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setTenantRefModal(null)}>
                    Annuler
                  </button>
                  <button className="btn btn-brand-primary" onClick={handleSaveTenantRef}>
                    Enregistrer
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }
      {debug(config.tenant)}
    </div >
  );
}
export default AdminOrdersList;
